<script>
import SimpleGroupSelect from '../UI/Form/SimpleGroupSelect.vue'

export default {
  components: {
    SimpleGroupSelect,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    items: {
      type: Array,
      default: [],
    },
    activeMenu: {
      type: String,
      default: null,
    },
    sticky: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:activeMenu'],
  computed: {
    wrapperClasses() {
      return {
        'topbar-submenu': true,
        'd-flex': true,
        'position-sticky': this.sticky,
        'position-static': !this.sticky,
      }
    },
  },
  methods: {
    getMenuClasses(menu) {
      return {
        'topbar-contract-menu': true,
        'd-flex': true,
        'align-items-center': true,
        'mx-1': true,
        'sub-active': menu === this.activeMenu,
        disabled: !this.items.find((item) => item.menu === menu)?.enabled,
      }
    },
    setActiveMenu(menu) {
      this.$emit('update:activeMenu', menu)
    },
  },
}
</script>
<template>
  <div :class="wrapperClasses">
    <div class="topbar-simulation-title col-md-4 d-flex align-items-center">
      <slot name="title">
        {{ title }}
      </slot>
    </div>
    <div class="mobile-menu row col-md-8">
      <SimpleGroupSelect
        :model-value="activeMenu"
        :label="$t('menu.select')"
        :pre-select-value="false"
        @transmitted="setActiveMenu"
      >
        <option v-for="(item, index) of items" :key="index" :value="item.menu">
          {{ item.label }}
        </option>
      </SimpleGroupSelect>
    </div>
    <div class="device-menu row col-md-8">
      <div
        v-for="(item, index) of items"
        :key="index"
        :class="getMenuClasses(item.menu)"
        @click="setActiveMenu(item.menu)"
      >
        <div v-if="item.index" class="topbar-contract-circle mr-2">{{ item.index }}</div>
        {{ item.label }}
      </div>
    </div>
  </div>
</template>
